onComplete(function () {
	var fadeEls = document.querySelectorAll('.fade-in-up');
	if (!fadeEls.length) return;

	if (!('IntersectionObserver' in window)) {
		fadeEls.forEach(function (el) {
			el.classList.add('is-visible');
		});
		return;
	}

	var observer = new IntersectionObserver(function (entries) {
		entries.forEach(function (entry) {
			if (!entry.isIntersecting) return;
			entry.target.classList.add('is-visible');
			observer.unobserve(entry.target);
		});
	}, {
		threshold: 0.15,
		rootMargin: '0px 0px -10% 0px'
	});

	fadeEls.forEach(function (el) {
		observer.observe(el);
	});



	// Searchbar

	gsap.to(".search-bar-static", {
		opacity: 1,
		y: 0,
		duration: 0.25,
		ease: "power2",
		scrollTrigger: {
			trigger: ".page-hero",
			start: "bottom bottom",
			toggleActions: "play none none none"
		}
	});

	// Heading + tekst


	const animationTitle = document.querySelectorAll('.animation-hero h1');
	const animationPara = document.querySelectorAll('.animation-hero p');

	let mm = gsap.matchMedia();

	mm.add("(min-width: 992px)", () => {
		let heroTimeline = gsap.timeline();

		heroTimeline
			.to(animationTitle, {
				opacity: 1,
				y: 0,
				duration: 0.5,
				ease: "power2.out"
			})
			.to(animationPara, {
				opacity: 1,
				y: 0,
				duration: 0.5,
				ease: "power2.out",
				stagger: 0.15
			});

		// Optioneel: cleanup-functie die draait als de query niet meer matcht
		return () => {
			heroTimeline.kill();
		};
	});


	// const searchInput = document.querySelector('input[name="q"]');
	// const HTML = document.querySelector('html')

	// const langCode = HTML.getAttribute('lang');

	// let phrases;

	// if (langCode == 'nl') {
	// 	phrases = [
	// 		"Hoe automatiseren we de orderstroom tussen onze webshop en ERP?",
	// 		"Schaalbare integratie voor ons CRM",
	// 		"Hoe vervangen we een instabiele of verouderde systeemkoppeling?",
	// 		"Celigo, n8n of maatwerk: welke oplossing past bij ons bedrijf?"
	// 	];

	// } else {
	// 	phrases = [
	// 		"How can we automate the order flow between our webshop and ERP?",
	// 		"Scalable integration for our CRM",
	// 		"How do we safely replace an unstable or legacy system integration?",
	// 		"Celigo, n8n, or custom: which solution fits our business?"
	// 	];
	// }

	// // Configuration for the typing speed (in milliseconds)
	// const typingSpeed = 100;
	// const erasingSpeed = 25;
	// const pauseTime = 1500; // Pause after a phrase is fully typed

	// let phraseIndex = 0;
	// let charIndex = 0;
	// let typingTimeout;
	// let erasingTimeout;

	// /**
	//  * Clears any running timeouts to stop the animation.
	//  */
	// function stopAnimation () {
	// 	clearTimeout(typingTimeout);
	// 	clearTimeout(erasingTimeout);
	// 	// Ensure the placeholder is completely clear when focused
	// 	searchInput.placeholder = "";
	// }

	// /**
	//  * Types a single character onto the placeholder.
	//  */
	// function type () {
	// 	if (searchInput === document.activeElement) {
	// 		// If the element is currently focused, stop the animation
	// 		stopAnimation();
	// 		return;
	// 	}

	// 	if (charIndex < phrases[phraseIndex].length) {
	// 		searchInput.placeholder += phrases[phraseIndex].charAt(charIndex);
	// 		charIndex++;
	// 		typingTimeout = setTimeout(type, typingSpeed);
	// 	} else {
	// 		typingTimeout = setTimeout(erase, pauseTime);
	// 	}
	// }

	// /**
	//  * Erases a single character from the placeholder.
	//  */
	// function erase () {
	// 	if (searchInput === document.activeElement) {
	// 		stopAnimation();
	// 		return;
	// 	}

	// 	if (charIndex > 0) {
	// 		searchInput.placeholder = phrases[phraseIndex].substring(0, charIndex - 1);
	// 		charIndex--;
	// 		erasingTimeout = setTimeout(erase, erasingSpeed);
	// 	} else {
	// 		phraseIndex = (phraseIndex + 1) % phrases.length;
	// 		charIndex = 0;
	// 		typingTimeout = setTimeout(type, typingSpeed);
	// 	}
	// }

	// searchInput.addEventListener('focus', stopAnimation);

	// searchInput.addEventListener('blur', () => {
	// 	if (searchInput.value.trim() === '') {
	// 		// Reset state to start the animation fresh
	// 		phraseIndex = 0;
	// 		charIndex = 0;
	// 		searchInput.placeholder = ""; // Ensure it's empty before starting
	// 		type();
	// 	}
	// });

	// type()

});

onInteractive(function () {
	var PX_PER_SEC = 40;
	var trackAnims = []; /* the CSS marquee animations we ease the speed of */

	function setupTrack(track) {
		var list = track.querySelector('.home-tags-list');
		if (!list) return;
		var clone = list.cloneNode(true);
		clone.classList.add('home-tags-list--clone');
		track.appendChild(clone);
		var distance = track.scrollWidth / 2;
		track.style.animationDuration = (distance / PX_PER_SEC) + 's';
		/* Collect the running CSS animation so we can vary its playbackRate.
		   Empty when prefers-reduced-motion disables the animation. */
		if (track.getAnimations) {
			track.getAnimations().forEach(function (a) {
				trackAnims.push(a);
			});
		}
	}

	document.querySelectorAll('.home-tags-track').forEach(setupTrack);

	document.querySelectorAll('[data-clone-reversed]').forEach(function (row) {
		var wrapper = row.querySelector('.container-xxl');
		if (!wrapper) return;
		var reversedWrapper = wrapper.cloneNode(true);
		var track = reversedWrapper.querySelector('.home-tags-track');
		track.classList.add('home-tags-track--reverse');
		var lists = track.querySelectorAll('.home-tags-list');
		lists.forEach(function (l, i) {
			if (i > 0) l.remove();
		});
		row.insertBefore(reversedWrapper, wrapper);
		setupTrack(track);
	});

	/* Scroll speed-up: same feel as the home waves. While scrolling the marquee
	   speed eases up to SCROLL_SPEED and settles back to normal shortly after the
	   last scroll event. Adjusting playbackRate keeps the position continuous, so
	   there are no visible jumps when the multiplier changes. */
	if (trackAnims.length) {
		var speed = 1,
			lastTs = null,
			lastScrollT = -1e9;
		var NORMAL_SPEED = 1,
			SCROLL_SPEED = 2.5,
			SCROLL_HOLD = 120; /* ms after last scroll before easing back */

		window.addEventListener('scroll', function () {
			lastScrollT = performance.now();
		}, {
			passive: true
		});

		function loop(ts) {
			requestAnimationFrame(loop);
			if (lastTs === null) lastTs = ts;
			var dt = Math.min((ts - lastTs) / 1000, 0.1); /* clamp big gaps (tab switch) */
			lastTs = ts;
			var target = (ts - lastScrollT < SCROLL_HOLD) ? SCROLL_SPEED : NORMAL_SPEED;
			speed += (target - speed) * Math.min(1, dt * 6); /* ease toward target */
			trackAnims.forEach(function (a) {
				a.playbackRate = speed;
			});
		}
		requestAnimationFrame(loop);
	}

	// How we do section: each step carries its own image so the CMS editor can
	// edit image and text together. On the public page the images are lifted into
	// one sticky stack that cross-fades as the matching text step scrolls by.
	const section = document.querySelector('.how-we-do');
	if (!section) return;

	const editing = document.body.hasAttribute('data-editor-mode');
	const imageStack = section.querySelector('.how-we-work-images');
	const steps = [...section.querySelectorAll('.how-we-work-text')];

	if (imageStack && !editing) {
		steps.forEach((step) => {
			const stepImage = step.querySelector('.how-we-work-image');
			if (stepImage) imageStack.appendChild(stepImage);
		});
	}

	const images = [...section.querySelectorAll('.how-we-work-image')];
	if (editing || !images.length || !steps.length) return;

	let current = -1;

	const activate = (i) => {
		if (i === current) return;
		current = i;
		images.forEach((img, idx) => {
			const on = idx === i;
			img.classList.toggle('is-active', on);
			if (window.gsap) {
				gsap.to(img, {
					opacity: on ? 1 : 0,
					duration: 0.6,
					ease: 'power2.out'
				});
			} else {
				img.style.opacity = on ? '1' : '0';
			}
		});
		steps.forEach((s, idx) => s.classList.toggle('is-active', idx === i));
	};

	activate(0);

	if ('IntersectionObserver' in window) {
		const io = new IntersectionObserver((entries) => {
			entries.forEach((e) => {
				if (e.isIntersecting) {
					const idx = steps.indexOf(e.target);
					if (idx !== -1) activate(idx);
				}
			});
		}, {
			rootMargin: '-50% 0px -50% 0px',
			threshold: 0
		});
		steps.forEach((s) => io.observe(s));
	}

});



// onComplete(function() {
// 	var canvas = document.getElementById('home-wave-canvas');
// 	var heroEl = document.querySelector('.home-wave-bottom');
// 	var ctx = canvas.getContext('2d');
// 	if (!ctx) return;

// 	var W = 0,
// 		H = 0,
// 		DPR = 1;
// 	/* Layout of the wave band, recomputed per frame from H. BASE = vertical
// 	   center, BAND = amplitude scale, GLOW = underglow blur radius. The band
// 	   is kept GLOW px above the bottom edge so the downward glow fades out
// 	   inside the canvas instead of being hard-clipped by the bottom. */
// 	var BASE = 0,
// 		BAND = 0,
// 		GLOW = 0;

// 	function resize() {
// 		DPR = Math.min(window.devicePixelRatio || 1, 2);
// 		W = window.innerWidth;
// 		H = heroEl.clientHeight || 200;
// 		canvas.width = Math.round(W * DPR);
// 		canvas.height = Math.round(H * DPR);
// 		canvas.style.width = W + 'px';
// 		canvas.style.height = H + 'px';
// 		ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
// 	}
// 	window.addEventListener('resize', resize, {
// 		passive: true
// 	});
// 	new ResizeObserver(resize).observe(heroEl);
// 	resize();

// 	var WAVES = [{
// 			c: '#54dbc7',
// 			amp: 0.38,
// 			freq: 0.80,
// 			spd: 0.28,
// 			ph: 0.00
// 		},
// 		{
// 			c: '#168f91',
// 			amp: 0.35,
// 			freq: 0.60,
// 			spd: 0.34,
// 			ph: Math.PI * 1.25
// 		},
// 		{
// 			c: '#187ca1',
// 			amp: 0.40,
// 			freq: 0.50,
// 			spd: 0.40,
// 			ph: Math.PI * 1.80
// 		},
// 	];

// 	function getY(wave, x, t) {
// 		var xn = x / W,
// 			amp = wave.amp * BAND;
// 		return BASE +
// 			Math.sin(xn * wave.freq * Math.PI * 2 + t * wave.spd + wave.ph) * amp +
// 			Math.sin(xn * wave.freq * 0.5 * Math.PI * 2 + t * wave.spd * 0.4 + wave.ph + 1.5) * amp * 0.10;
// 	}

// 	/* Split the canvas into a wave band (top) + a glow margin M (bottom). The
// 	   waves keep the full band-region amplitude (the larger amps we want), and
// 	   the downward glow fades out inside M. A blur(r) is a Gaussian that only
// 	   reaches ~0 after ~3r, so GLOW = M/3 keeps the glow off the bottom edge. */
// 	function computeLayout() {
// 		var M = Math.min(H * 0.30, 95); /* fixed-ish glow room at the bottom */
// 		GLOW = M / 3; /* blur(r) fades to ~0 only after ~3r */
// 		var bandRegion = H - M; /* waves live in this region; glow fills M below it */
// 		BAND = bandRegion; /* amplitude scale = full band region (restores the earlier, larger amps) */
// 		BASE = bandRegion * 0.5; /* center the waves in the band region, above the glow margin */
// 	}

// 	function tracePath(wave, t) {
// 		ctx.beginPath();
// 		for (var x = 0; x <= W; x += 4) {
// 			var y = getY(wave, x, t);
// 			if (x === 0) ctx.moveTo(x, y);
// 			else ctx.lineTo(x, y);
// 		}
// 	}

// 	function hexRgba(hex, a) {
// 		return 'rgba(' + parseInt(hex.slice(1, 3), 16) + ',' + parseInt(hex.slice(3, 5), 16) + ',' + parseInt(hex.slice(5, 7), 16) + ',' + a + ')';
// 	}

// 	var HIGHLIGHTS = [{
// 			wi: 0,
// 			pos: 0.15,
// 			spd: 0.038
// 		},
// 		{
// 			wi: 0,
// 			pos: 0.65,
// 			spd: 0.038
// 		},
// 		{
// 			wi: 1,
// 			pos: 0.40,
// 			spd: 0.030
// 		},
// 		{
// 			wi: 1,
// 			pos: 0.90,
// 			spd: 0.030
// 		},
// 		{
// 			wi: 2,
// 			pos: 0.25,
// 			spd: 0.044
// 		},
// 		{
// 			wi: 2,
// 			pos: 0.75,
// 			spd: 0.044
// 		},
// 	];

// 	function drawHighlights(t) {
// 		ctx.globalCompositeOperation = 'lighter';
// 		ctx.filter = 'none';
// 		for (var i = 0; i < HIGHLIGHTS.length; i++) {
// 			var h = HIGHLIGHTS[i];
// 			var wave = WAVES[h.wi];
// 			var pos = (h.pos + t * h.spd) % 1.0;
// 			var x = pos * W;
// 			var y = getY(wave, x, t);
// 			var r = 18;
// 			var grad = ctx.createRadialGradient(0, 0, 0, 0, 0, r);
// 			grad.addColorStop(0, 'rgba(255,255,255,0.35)');
// 			grad.addColorStop(0.3, hexRgba(wave.c, 0.18));
// 			grad.addColorStop(1, 'rgba(0,0,0,0)');
// 			ctx.save();
// 			ctx.translate(x, y);
// 			ctx.scale(3.5, 1);
// 			ctx.globalAlpha = 1;
// 			ctx.fillStyle = grad;
// 			ctx.beginPath();
// 			ctx.arc(0, 0, r, 0, Math.PI * 2);
// 			ctx.fill();
// 			ctx.restore();
// 		}
// 	}

// 	var visible = true;
// 	if ('IntersectionObserver' in window) {
// 		new IntersectionObserver(function(e) {
// 			visible = e[0].isIntersecting;
// 		}, {
// 			threshold: 0
// 		}).observe(heroEl);
// 	}

// 	/* Scroll speed-up: instead of feeding the raw timestamp into the waves,
// 	   we accumulate our own sim time at a variable rate. While scrolling the
// 	   rate eases up to SCROLL_SPEED, and it eases back to 1 shortly after the
// 	   last scroll event — so the waves subtly quicken on scroll and settle
// 	   back to normal when it stops. Accumulating (rather than scaling ts
// 	   directly) avoids visible jumps when the multiplier changes. */
// 	var simTime = 0,
// 		lastTs = null,
// 		speed = 1,
// 		lastScrollT = -1e9;
// 	var NORMAL_SPEED = 1,
// 		SCROLL_SPEED = 3.5,
// 		SCROLL_HOLD = 120; /* ms after last scroll before easing back */
// 	window.addEventListener('scroll', function() {
// 		lastScrollT = performance.now();
// 	}, {
// 		passive: true
// 	});

// 	function loop(ts) {
// 		requestAnimationFrame(loop);
// 		if (!visible || !W || !H) return;
// 		if (lastTs === null) lastTs = ts;
// 		var dt = Math.min((ts - lastTs) / 1000, 0.1); /* clamp big gaps (tab switch) */
// 		lastTs = ts;
// 		var target = (ts - lastScrollT < SCROLL_HOLD) ? SCROLL_SPEED : NORMAL_SPEED;
// 		speed += (target - speed) * Math.min(1, dt * 6); /* ease toward target */
// 		simTime += dt * speed;
// 		var t = simTime;
// 		computeLayout();

// 		// Opaque background
// 		ctx.globalCompositeOperation = 'source-over';
// 		ctx.globalAlpha = 1;
// 		ctx.fillStyle = '#0D171A';
// 		ctx.fillRect(0, 0, W, H);

// 		// All wave passes — lighter so glow and cores all accumulate additively
// 		ctx.globalCompositeOperation = 'lighter';
// 		for (var i = 0; i < WAVES.length; i++) {
// 			var w = WAVES[i];
// 			ctx.strokeStyle = w.c;

// 			// Outer wide Gaussian glow
// 			tracePath(w, t);
// 			ctx.filter = 'blur(14px)';
// 			ctx.lineWidth = 2;
// 			ctx.globalAlpha = 0.22;
// 			ctx.stroke();

// 			// Inner glow
// 			tracePath(w, t);
// 			ctx.filter = 'blur(4px)';
// 			ctx.lineWidth = 1.5;
// 			ctx.globalAlpha = 0.55;
// 			ctx.stroke();

// 			// Sharp bright core
// 			tracePath(w, t);
// 			ctx.filter = 'none';
// 			ctx.lineWidth = 1.5;
// 			ctx.globalAlpha = 0.72;
// 			ctx.stroke();
// 		}

// 		// Underglow — clipped to below the wave so glow only falls downward
// 		ctx.filter = 'none';
// 		for (var i = 0; i < WAVES.length; i++) {
// 			var w = WAVES[i];
// 			ctx.save();
// 			ctx.beginPath();
// 			for (var x = 0; x <= W; x += 4) {
// 				var y = getY(w, x, t);
// 				if (x === 0) ctx.moveTo(x, y);
// 				else ctx.lineTo(x, y);
// 			}
// 			ctx.lineTo(W, H + 10);
// 			ctx.lineTo(0, H + 10);
// 			ctx.closePath();
// 			ctx.clip();
// 			ctx.globalCompositeOperation = 'lighter';
// 			ctx.strokeStyle = w.c;
// 			ctx.filter = 'blur(' + GLOW + 'px)';
// 			ctx.lineWidth = 4;
// 			ctx.globalAlpha = 1;
// 			tracePath(w, t);
// 			ctx.stroke();
// 			// Second pass stacks additively under 'lighter' for extra brightness
// 			ctx.filter = 'blur(' + (GLOW * 0.5) + 'px)';
// 			ctx.lineWidth = 2;
// 			ctx.globalAlpha = 0.7;
// 			tracePath(w, t);
// 			ctx.stroke();
// 			ctx.restore();
// 		}

// 		ctx.filter = 'none';
// 		drawHighlights(t);

// 		// Edge fade
// 		ctx.globalCompositeOperation = 'source-over';
// 		ctx.filter = 'none';
// 		ctx.globalAlpha = 1;
// 		var fw = Math.round(W * 0.10);
// 		var gl = ctx.createLinearGradient(0, 0, fw, 0);
// 		gl.addColorStop(0, '#0D171A');
// 		gl.addColorStop(1, 'rgba(13,23,26,0)');
// 		ctx.fillStyle = gl;
// 		ctx.fillRect(0, 0, fw, H);
// 		var gr = ctx.createLinearGradient(W - fw, 0, W, 0);
// 		gr.addColorStop(0, 'rgba(13,23,26,0)');
// 		gr.addColorStop(1, '#0D171A');
// 		ctx.fillStyle = gr;
// 		ctx.fillRect(W - fw, 0, fw, H);
// 	}
// 	requestAnimationFrame(loop);
// })